import { render } from "./ReceiverManagementContainer.vue?vue&type=template&id=7df45f2c"
import script from "./ReceiverManagementContainer.vue?vue&type=script&lang=js"
export * from "./ReceiverManagementContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__